
    import { Component } from 'vue-property-decorator';
    import RepsolFilterBarComponent from '@/components/repsol-filter-bar/RepsolFilterBarComponent.vue';
    import RepsolFilterChipsComponent from '@/components/repsol-filter-chips/RepsolFilterChipsComponent.vue';
    import RepsolTableComponent from '@/components/repsol-table/RepsolTableComponent.vue';
    import RepsolFormPopupComponent from '@/components/repsol-form-popup/RepsolFormPopupComponent.vue'
    import { Chip, FormFields, FilterFields, TableHeaderModel } from  '@/models/repsol-template.model';
    import { namespace } from 'vuex-class';
    import ComponentBase from '@/mixins/componentBase';
    import RepsolDialog from '@/components/RepsolDialog.vue';

    @Component({
        name: 'UsuariosPage',
        components: {
            RepsolFilterBarComponent,
            RepsolFilterChipsComponent,
            RepsolTableComponent,
            RepsolFormPopupComponent,
            RepsolDialog
        },
    })

    class UsuariosPage extends ComponentBase {

        isOpenFilters = false;
        isOpenForm = false;
        formIsValid = true;
        formOnlyRead = false;

        deleteFilter = "";

        popupHeaderText = "";

        filterChips:Chip[] = [];

        formFields : FormFields[] = [];

        filterFields : FilterFields[] = [];

        ambitoField:any = {
            label: 'common.desk',
            name: 'mesaId',
            as: 'selectlist',
            model: [],
            isDisabled: false,
            isRequired: true,
            multiple: false,
            canView: true,
            cols: 4
        };

        items:any[] = [];

        itemEdit:any = {};

        tableHeaders:TableHeaderModel[] = [];

        itemEliminar: any = {};

        showDialog = false;

        tableLoading = false;
        totalItems = 0;

        tableOptions = {
            page: 1,
            itemsPerPage: 10,
            sortBy: [] as string[],
            sortDesc: [] as boolean[],
        };

        constructor() {
          super();
        }

        mounted() {
          this.ambitoField.items = this.maestroMesa;
          this.formFields  =  [
              {
                  label: 'common.full_name',
                  name: 'nombre',
                  as: 'text',
                  model: '',
                  isDisabled: false,
                  isRequired: true,
                  canView: true,
                  cols: 6
              },
              {
                label: 'common.email',
                name: 'email',
                as: 'text',
                model: '',
                isDisabled: false,
                isRequired: true,
                canView: true,
                cols: 6
            },
            {
                label: 'common.trader_code',
                name: 'codigoTrader',
                as: 'text',
                model: '',
                isDisabled: false,
                isRequired: true,
                canView: true,
                cols: 4
            },
            {
                label: 'usuarios.user_profile',
                name: 'perfilId',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: true,
                items: this.maestroPerfil,
                multiple: false,
                canView: true,
                cols: 4
            },
            this.ambitoField,
            {
                label: 'common.active',
                name: 'activo',
                as: 'radio',
                items:this.maestroSiNo,
                model: '',
                isDisabled: false,
                isRequired: false,
                canView: true,
                cols: 4
            }
        ];

        this.filterFields = [
          {
                label: 'common.trader_code',
                name: 'codigoTrader',
                as: 'text',
                model: '',
                isDisabled: false,
                isRequired: false
            },
            {
                label: 'common.full_name',
                name: 'nombre',
                as: 'text',
                model: '',
                isDisabled: false,
                isRequired: false
            },
            {
                label: 'common.email',
                name: 'email',
                as: 'text',
                model: '',
                isDisabled: false,
                isRequired: false
            },
            {
                label: 'common.desk',
                name: 'mesaId',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: false,
                items: this.maestroMesaBase,
                multiple: true
            },
            {
                label: 'usuarios.user_profile',
                name: 'perfilId',
                as: 'selectlist',
                model: '',
                isDisabled: false,
                isRequired: false,
                items: this.maestroPerfil,
                multiple: true
            }
        ];

          this.tableHeaders = [
            { text: 'common.identifier', value: "id", sortable: true, as:'number' },
            { text: "common.trader_code", value: "codigoTrader", sortable: true, as:'number' },
            { text: "common.full_name", value: "nombre", sortable: true, as: 'text'},
            { text: "common.email", value: "email", sortable: true, as: 'text' },
            { text: "usuarios.user_profile", value: "perfilId", sortable: true, as: 'select', items:this.maestroPerfil },
            { text: "common.desk", value: "mesaId", sortable: true, as: 'select', items: this.maestroMesaBase},
            { text: "common.active", value: "activo", sortable: true, as: 'select', items: this.maestroSiNo},
            { text: '', value: "actions", sortable: false, as:'', actions:[
                {icon: 'mdi-close', name: 'eliminar'},
                {icon: 'edit', name: 'editar'}
            ] },
        ];
          this.getUsuariosList();
          this.getMaestroPerfil();
          this.getMaestroMesa();
        }

       onTableOptionsChanged(options: any) {
        this.tableOptions = { ...options };
        this.getUsuariosList();
        }

        async getUsuariosList(){

            this.openSpinner("usuarios.cargarListado");

            this.items = [];
            const filtro: any = {};
              this.filterFields.forEach(f =>{
                if(f.model){
                    filtro[f.name] = f.model;
                }
            });

            const page = this.tableOptions?.page ?? 1;
            const itemsPerPage = this.tableOptions?.itemsPerPage ?? 10;
            const sortBy = this.tableOptions?.sortBy ?? [];
            const sortDesc = this.tableOptions?.sortDesc ?? [];
            filtro.PageNumber = page || 1;
            filtro.PageSize = itemsPerPage || 10;

           if (sortBy && sortBy.length) {
            filtro.sortBy = sortBy[0];
            filtro.sortDesc = !!(sortDesc && sortDesc[0]);
            }

            const route = '/api/usuario/list';
            this.post({ apiUrl: route, entity: filtro })
            .then(data => {
                console.log(data.items);
                if (Array.isArray(data.items)) {
                this.items = data.items;
                this.totalItems = data.totalCount ?? 0;
            } else {
                this.items = data?.items ?? [];
                this.totalItems = data?.totalCount ?? 0;
            }
            })
            .catch(error =>{
                this.mostrarKO("usuarios.koListado");
            })
            .finally(() => {
                this.closeSpinner();
            });
        }

        nuevoElemento() : void {
            this.popupHeaderText = "usuarios.nuevoElemento";
            this.itemEdit = {activo:true};
            this.isOpenForm = true;
        }

        tableEventAction(action:string, item:any): void{
            switch (action) {
                case 'eliminar':
                    this.itemEliminar = item;
                    this.showDialog = true;

                  break;
                case 'editar':
                    this.popupHeaderText = "usuarios.editarElemento";
                    this.itemEdit = {};
                    this.openSpinner("usuarios.cargar");
                    this.get({ apiUrl: `/api/usuario/${item.id}`})
                      .then((response) => {
                            this.itemEdit = response;
                            this.itemEdit["$item_id"] = item.id;
                            this.closeSpinner();
                            this.isOpenForm = true;
                      })
                      .catch(() => {
                          this.mostrarKO(this.$i18n.t("usuarios.errorCargar").toString());
                          this.closeSpinner();
                      });

                    break;
                default:
                    break;
            }
        }

      private eliminarUsuario() {
        this.showDialog = false;
        this.openSpinner("usuarios.eliminarExitosa");
        this.delete({ apiUrl: `/api/usuario`, entity: this.itemEliminar })
          .then(() => {
            // Manejar la respuesta si es necesario
            this.closeSpinner();
            this.mostrarOK("usuarios.eliminarExitosa");
            // Actualizar el listado después de la eliminación
            this.getUsuariosList();
          })
          .catch(() => {

            this.closeSpinner();
            this.mostrarKO("usuarios.errorEliminar");
          });
      }

        formEventAction(action:string, item:any): void{
            switch (action) {
                case 'salvar':
                    if(this.userIdentity.perfilId == 'CEN' && item.perfilId == 'ADM' && this.userIdentity.id == item.$item_id)
                    {
                        this.mostrarKO("usuarios.errorActualizacion");
                        break;
                    }
                    if (item["$item_id"]) {
                       this.openSpinner("usuarios.actualizarElemento");
                      // Realizar la llamada a la API para actualizar el elemento
                      this.put({ apiUrl: `/api/usuario/${item["$item_id"]}`, entity: item })
                          .then(() => {
                             this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("usuarios.actualizacionExitosa");
                              this.getUsuariosList();
                          })
                          .catch(() => {
                              // Manejar errores si es necesario
                                this.closeSpinner();
                              this.mostrarKO(this.$i18n.t("usuarios.errorActualizacion").toString());
                          });
                  } else {
                      // Crear y listado
                      // Aquí realizamos la llamada a la API para crear un nuevo elemento
                      this.openSpinner("usuarios.crearElemento");
                      this.post({ apiUrl: '/api/usuario', entity: item })
                          .then(() => {
                              this.isOpenForm = false;
                              this.closeSpinner();
                              this.mostrarOK("usuarios.creacionExitosa");
                              this.getUsuariosList();
                          })
                          .catch(() => {
                              // Manejar errores si es necesario
                                this.closeSpinner();
                              this.mostrarKO("usuarios.errorCreacion");
                          });
                  }
                  break;

                case 'cancelar':
                    this.isOpenForm = false;
                    break;

                case 'cambio':
                    if(this.itemEdit.perfilId == 'MESA' || this.itemEdit.perfilId == 'MLECT') {
                        this.ambitoField.canView = true;
                        this.ambitoField.items = this.maestroMesa;
                        this.rulesForm.mesaId = [(field: string) => !!field || this.$t("validations_form.required")] as any;
                    }else if(this.itemEdit.perfilId == 'CONTR') {
                        this.ambitoField.canView = true;
                        this.ambitoField.items = this.maestroMesaContraparte;
                        this.rulesForm.mesaId = [(field: string) => !!field || this.$t("validations_form.required")] as any;
                    }else{
                        this.itemEdit.mesaId = null;
                        this.ambitoField.canView = false;
                        this.rulesForm.mesaId = [(field:string) => true];
                    }
                    break;
                default:
                    break;
            }
        }

        changeFilters(): void {
            this.filterChips.splice(0);
            this.filterFields.forEach(f =>{
                if(f.model){
                    if(Array.isArray(f.model)){
                        f.model.forEach(m =>{
                            this.filterChips.push({clave:`${f.name}-${m.id}`, valor:m.nombre, tooltip: f.label});
                        })
                    }
                    else
                    {
                        this.filterChips.push({clave:`${f.name}`, valor: f.model as string, tooltip: f.label});
                    }
                }
            });


            this.isOpenFilters = false;

            this.getUsuariosList();
        }

        removeChip(clave: string): void {
            if(clave){
                this.filterChips = this.filterChips.filter(c => c.clave != clave);

                var name = clave.split('-')[0];
                var field = this.filterFields.find(f => f.name == name);
                if(field){
                    if(Array.isArray(field.model)){
                        var id = clave.split('-')[1];
                        field.model = field.model.filter(m => m.id != id);
                    }
                    else
                    {
                        field.model = '';
                    }
                }
                this.getUsuariosList();
            }
        }

        rulesForm = {
            nombre: [this.required(),this.maxLen(255)],
            email: [this.required(), this.maxLen(100),this.validarEmail()],
            codigoTrader: [this.required(), this.maxLen(50)],
            activo: [this.required()],
            perfilId: [this.required(), this.maxLen(5)],
            mesaId: [this.required(),this.maxLen(5)]

        };
    }

    export default UsuariosPage;
